import { ApplicationState } from '../../store/rootReducer';

export const getAreItemsLoaded = (state: ApplicationState): boolean => {
    return state.users.itemList.loaded;
};